import React from "react";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import useGtmCustomEvent from "@/hooks/gtm/use-gtm-custom-events";

type CoverOptionProps = {
  code: string;
  title: string;
  fullPrice: string;
  monthlyPrice: string;
  totalPrice: string;
  description: string;
  state: string;
  isGolfEquipment?: boolean;
  actionLabel: string;
  action: (code: string, title: string) => void;
};

function CoverOption({
  code,
  title,
  fullPrice,
  monthlyPrice,
  totalPrice,
  description,
  state,
  isGolfEquipment = false,
  actionLabel,
  action,
}: Readonly<CoverOptionProps>) {
  const handleGtmEvent = useGtmCustomEvent({
    event: "custom_events",
    eventName: "edit_policy_extras",
    policyExtra: title.toLowerCase(),
    buttonLabel: actionLabel,
  });
  return (
    <div className="flex flex-col items-start self-stretch">
      <div className="flex pb-spacing-xs flex-col items-start self-stretch">
        <h2 className="md:w-[452px] text-text-functional-subtle font-body-font text-2xs font-bold leading-6">
          {title}
        </h2>
        <p className="self-stretch text-text-title font-body-font text-2xs font-normal leading-6">
          {isGolfEquipment ? (
            <span className="block">
              From <span className="font-bold">{fullPrice}</span>
            </span>
          ) : (
            <>
              <span className="font-bold">{fullPrice}</span> in full or{" "}
              <span className="block">
                <span className="font-bold">{monthlyPrice}</span> a month (total{" "}
                {totalPrice})
              </span>
            </>
          )}
        </p>
        <RichText
          richText={description}
          className="md:w-[382px] text-text-functional-1 font-body-font text-2xs font-normal leading-6"
        />
      </div>
      <div className="flex flex-col items-start gap-spacing-xs self-stretch">
        <div className="flex flex-grow flex-shrink-0 basis-0 justify-between items-center self-stretch">
          <span className="text-interactive-secondary-default font-body-font text-xs font-bold leading-[27px]">
            {state}
          </span>
          <LabelButtonWrapper
            label={actionLabel}
            hierarchy="tertiary"
            className="flex justify-center items-center text-interactive-secondary-default font-body-font text-xs font-semibold leading-[18px] relative top-[-2px] !px-spacing-xxs"
            onClick={() => {
              action(code, title);
              handleGtmEvent();
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default CoverOption;
